function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import equals from 'ramda/src/equals';
import { stateGo } from 'redux-ui-router';
import { NON_BULK_SERVICE_STATUSES } from 'invision-core/src/constants/status.constants';
import { CurrentCustomerIdSelector, CurrentCustomerCurrencyCodeSelector } from '../../../../../../reducers/selectors/customer.selectors';
import { suspendOrResumeServices } from '../../../../../../reducers/actions/services.actions';
import CustomerLocaleKeys from '../../../../../../locales/keys';
import { HasSuspendResumePermissionSelector, ResumeServiceReasonCodesSelector, SuspendServiceReasonCodesSelector } from '../../../../../../reducers/selectors/services.selectors';
import { SelectedSubscriberOfferServiceCountSelector } from '../../../../../../reducers/selectors/search.subscriber.offerings.selectors';
import { SERVICES_USAGE_STATE_NAME } from '../../../../../customer/servicesAndUsage/services.and.usage.config';
import { NUMBER_OF_SERVICES_TO_DISPLAY } from '../services.and.offers.contants';
import { getSuspensionTypeByCode } from '../../../../../../reducers/selectors/services.list.selectors.helper';
import { RESUME_SERVICES_REDIRECT, SUSPEND_SERVICES_REDIRECT, SERVICE_ADD_ON_PRODUCTS_ORDERING_PAGE_ROUTE } from '../../../../../../reactRoutes';
var SubscriberServicesController = /*#__PURE__*/function () {
  function SubscriberServicesController($ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, SubscriberServicesController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      CustomerLocaleKeys: CustomerLocaleKeys,
      NUMBER_OF_SERVICES_TO_DISPLAY: NUMBER_OF_SERVICES_TO_DISPLAY,
      onCloseUpdateFriendlyNameModal: this.onCloseUpdateFriendlyNameModal.bind(this),
      onMoreMenuItemSelected: this.onMoreMenuItemSelected.bind(this),
      onSubmitUpdateFriendlyName: this.onSubmitUpdateFriendlyName.bind(this),
      onCloseUpdateServiceLifeCycleStatusModal: this.onCloseUpdateServiceLifeCycleStatusModal.bind(this),
      SERVICES_USAGE_STATE_NAME: SERVICES_USAGE_STATE_NAME,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(SubscriberServicesController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        stateGo: stateGo,
        suspendOrResumeServices: suspendOrResumeServices
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentCustomerId: CurrentCustomerIdSelector(store),
          hasSuspendResumeAccess: HasSuspendResumePermissionSelector(store),
          resumeServiceReasonCodes: ResumeServiceReasonCodesSelector(store),
          servicesCount: SelectedSubscriberOfferServiceCountSelector(store),
          subscriberCurrencyCode: CurrentCustomerCurrencyCodeSelector(store),
          suspendServiceReasonCodes: SuspendServiceReasonCodesSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.updateFriendlyNameModalConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.updateFriendlyNameModalConfigApi = api;
        }
      };
      this.updateServiceLifeCycleStatusConfig = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this.updateServiceLifeCycleStatusConfigApi = api;
        }
      };
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (this.state && changesObj.serviceDetails && !equals(changesObj.serviceDetails.currentValue, changesObj.serviceDetails.previousValue)) {
        this.suspendType = getSuspensionTypeByCode(this.serviceDetails.SuspendTypeCode);
      }
    }
  }, {
    key: "onMoreMenuItemSelected",
    value: function onMoreMenuItemSelected(serviceDetails) {
      var _this2 = this;
      return function (_ref3) {
        var itemProps = _ref3.item;
        _this2.selectedService = serviceDetails;
        switch (itemProps.id) {
          case CustomerLocaleKeys.MANAGE_ADD_ONS:
            if (!itemProps.isLocked) {
              _this2.actions.stateGo(SERVICE_ADD_ON_PRODUCTS_ORDERING_PAGE_ROUTE, {
                customerId: _this2.state.currentCustomerId,
                serviceIdentifierValue: serviceDetails.ServiceIdentifier.Value,
                serviceId: serviceDetails.serviceId,
                serviceAttributeId: serviceDetails.ServiceIdentifier.ServiceAttributeId
              });
            }
            break;
          case CustomerLocaleKeys.CUSTOMER_DASHBOARD.FRIENDLY_NAME.MODAL_TITLE:
            _this2.showUpdateFriendlyNameModal = true;
            _this2.$timeout(function () {
              _this2.updateFriendlyNameModalConfigApi.open();
            });
            break;
          case CustomerLocaleKeys.SUSPEND_SERVICE:
          case CustomerLocaleKeys.RESUME_SERVICE:
            _this2.openSuspendResumeServiceModal();
            break;
          case CustomerLocaleKeys.UPDATE_SERVICE_LIFECYCLE_STATUS:
            _this2.showUpdateServiceLifeCycleStatusModal = true;
            _this2.$timeout(function () {
              _this2.updateServiceLifeCycleStatusConfigApi.open();
            });
            break;
          default:
            break;
        }
      };
    }
  }, {
    key: "onSubmitUpdateFriendlyName",
    value: function onSubmitUpdateFriendlyName() {
      this.refreshOfferDetails && this.refreshOfferDetails();
      this.onCloseUpdateFriendlyNameModal();
    }
  }, {
    key: "onCloseUpdateFriendlyNameModal",
    value: function onCloseUpdateFriendlyNameModal() {
      this.showUpdateFriendlyNameModal = false;
      this.updateFriendlyNameModalConfigApi.close();
    }
  }, {
    key: "onCloseUpdateServiceLifeCycleStatusModal",
    value: function onCloseUpdateServiceLifeCycleStatusModal() {
      this.showUpdateServiceLifeCycleStatusModal = false;
      this.updateServiceLifeCycleStatusConfigApi.close();
    }
  }, {
    key: "onSubmitUpdateServiceLifeCycleStatus",
    value: function onSubmitUpdateServiceLifeCycleStatus() {
      this.onCloseUpdateServiceLifeCycleStatusModal();
    }
  }, {
    key: "openSuspendResumeServiceModal",
    value: function openSuspendResumeServiceModal() {
      if (this.selectedService.Status === NON_BULK_SERVICE_STATUSES.ACTIVE) {
        this.actions.stateGo(SUSPEND_SERVICES_REDIRECT, {
          customerId: this.state.currentCustomerId,
          serviceIdentifier: this.selectedService.ServiceIdentifier.Value
        });
      } else {
        this.actions.stateGo(RESUME_SERVICES_REDIRECT, {
          customerId: this.state.currentCustomerId,
          serviceIdentifier: this.selectedService.ServiceIdentifier.Value
        });
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  bindings: {
    offer: '<',
    refreshConvergentBillerDetails: '&?',
    refreshOfferDetails: '&?',
    serviceDetails: '<?'
  },
  template: require('./subscriber.services.html'),
  controller: SubscriberServicesController
};